export default __webpack_public_path__ + "locales/en/UploadPanel.json?hash=771afc7561dd11eae8a0bf6e6b4e0f33";